import React, { useState, useEffect, useContext } from "react";
import languageContext from "../context/language/languageContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

const WardenStudentDashboard = () => {
  const [students, setStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const { setSessionTimeout, setAlert, setMessage } = useContext(languageContext);

  const navigate = useNavigate();

  const getStudentDetails = async () => {
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    try {
      setLoading(true);
      const response = await axios.post(
        "https://www.careplus.gopillz.com/warden_school_details_interaction",
        {},
        { headers: headersList }
      );
      if (response.status === 200) {
        setStudents(response.data?.data);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const getStudentDetailsSearch = async (value) => {
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    try {
      setLoading(true);
      const response = await axios.post(
        "https://www.careplus.gopillz.com/warden_school_details_interaction",
        { search: value },
        { headers: headersList }
      );
      if (response.status === 200) {
        setStudents(response.data?.data);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleError = (error) => {
    setLoading(false);
    if (error.response?.data?.detail === "Token has expired") {
      setSessionTimeout(true);
    } else {
      setAlert(true);
      setMessage("Something went wrong. Please try again.");
    }
  };

  useEffect(() => {
    const init = async () => {
      const currentPagePath = window.location.pathname;
      const loginBool = localStorage.getItem("login");

      if (loginBool === "true") {
        navigate("/student-details", { state: { url: currentPagePath } });
        await getStudentDetails();
      } else {
        navigate("/login", { state: { url: currentPagePath } });
      }
    };
    init();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getStudentDetailsSearch(searchTerm.trim());
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const handleView = (path, student_id) =>
    navigate(path, { state: { patient_id: student_id } });

  return (
    <div className="min-h-screen bg-gradient-to-tr from-blue-50 to-blue-100">
      <Navbar />

      <div className="container mx-auto px-4 pt-28 pb-16">
        <h1 className="text-4xl font-bold text-blue-800 mb-6 text-center">
          Warden Dashboard – Student Monitoring
        </h1>
        <p className="text-center text-gray-600 mb-10">
          Review student health activity, appointments, lab results, and leave status.
        </p>

        {/* Search */}
        <div className="flex justify-center mb-8">
          <input
            type="text"
            placeholder="🔍 Search by Name, UID, or Phone"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full max-w-md px-5 py-2 rounded-xl border border-blue-300 shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Student Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-2">
          {loading ? (
            <div className="col-span-full flex justify-center items-center h-40">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-600 border-b-4"></div>
            </div>
          ) : students.length === 0 ? (
            <p className="text-center text-gray-600 col-span-full">No students found.</p>
          ) : (
            students.map((student) => (
              <div
                key={student.id}
                className="bg-white rounded-2xl p-6 border border-blue-200 shadow hover:shadow-xl transition transform hover:scale-[1.01]"
              >
                <h2 className="text-xl font-semibold text-blue-800">{student.name}</h2>
                <p className="text-gray-600 text-sm mt-1">📱 {student.phone}</p>
                <p className="text-gray-600 text-sm">🎂 Age: {student.age || "N/A"}</p>
                <p className="text-gray-600 text-sm">⚧ Gender: {student.gender}</p>
                <p className="text-gray-600 text-sm">🏫 UID: {student.uid}</p>
                <p className="text-gray-600 text-sm">🏠 Hostel: {student.hostel}</p>
                <p className="text-gray-600 text-sm">👨‍🏫 Warden: {student.warden} ({student.warden_phone_number})</p>

                <div className="mt-5 grid grid-cols-1 gap-2">
                  <button
                    onClick={() => handleView("/chat_history", student.id)}
                    className="w-full bg-indigo-500 hover:bg-indigo-600 text-white py-2 rounded-lg text-sm"
                  >
                    💬 Chat History
                  </button>
                  <button
                    onClick={() => handleView("/view_appointment", student.id)}
                    className="w-full bg-teal-500 hover:bg-teal-600 text-white py-2 rounded-lg text-sm"
                  >
                    📅 Appointments
                  </button>
                  <button
                    onClick={() => handleView("/view_lab_test", student.id)}
                    className="w-full bg-violet-500 hover:bg-violet-600 text-white py-2 rounded-lg text-sm"
                  >
                    🧪 Lab Tests
                  </button>
                  <button
                    onClick={() => handleView("/view_leave_alerts", student.id)}
                    className="w-full bg-orange-500 hover:bg-orange-600 text-white py-2 rounded-lg text-sm"
                  >
                    🚪 Leave Requests
                  </button>
                  <button
                    onClick={() => handleView("/prescription_history", student.id)}
                    className="w-full bg-gray-400 hover:bg-gray-500 text-white py-2 rounded-lg text-sm cursor-not-allowed"
                    
                  >
                    🔒 Prescription View Only
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default WardenStudentDashboard;
